"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sorting = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../BannerProductListing/constants");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Sorting component
 *
 * State: Candidate for component extraction when it will be reused in design.
 *
 * @param options
 * @param onChange
 * @constructor
 */ const Sorting = (param)=>{
    let { options, onChange } = param;
    var _options_;
    const ref = (0, _react.useRef)(null);
    var _options__label;
    const [selected, setSelected] = (0, _react.useState)((_options__label = (_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.label) !== null && _options__label !== void 0 ? _options__label : _constants.DEFAULT_ORDER_BY);
    const { getTestId } = (0, _testidGenerator.default)();
    const { onClose, onToggle, open } = (0, _presentationHooks.useDisclose)();
    const onButtonClick = (0, _react.useCallback)((event)=>{
        event.stopPropagation();
        onToggle();
    }, [
        onToggle
    ]);
    (0, _presentationHooks.useListenToKeyDown)([
        'Escape'
    ], ()=>{
        onClose();
    });
    const onClick = (0, _react.useCallback)((value, displayText)=>()=>{
            setSelected(displayText);
            onClose();
            onChange(value);
        }, [
        onChange,
        onClose
    ]);
    if (!options.length) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.SortButton, {
                ref: ref,
                "data-testid": getTestId(_constants2.SORTING),
                onClick: onButtonClick,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Sort, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        fontWeight: "bold",
                        color: "textPrimary",
                        textTransform: "uppercase",
                        children: selected
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.ClickAwayListener, {
                onClickAway: onClose,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SortMenu, {
                    "data-testid": getTestId(_constants2.SORTING_MENU),
                    open: open,
                    anchorEl: ref.current,
                    placement: "bottom-end",
                    children: options.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SortItem, {
                            value: option.key,
                            onClick: onClick(option.key, option.label),
                            children: option.label
                        }, option.key))
                })
            })
        ]
    });
};
exports.Sorting = Sorting;
